import React, { FunctionComponent } from "react";
import { HeroCta } from "../cta/HeroCta";
import { Pattern } from "../Pattern";

import HeroTitle from "../typography/HeroTitle";
import LeadText from "../typography/LeadText";
import TitleTag from "../typography/TitleTag";

type ImageHero4Props = {
  tag: string;
  title: JSX.Element;
  description: string | JSX.Element;
  image: string;
  cta?: JSX.Element;
  topCta?: JSX.Element;
  dark?: boolean;
};

const ImageHero4: FunctionComponent<ImageHero4Props> = ({
  tag,
  title,
  description,
  image,
  dark = false,
  topCta,
  cta = <HeroCta />,
}) => {
  return (
    <div
      className={`w-full ${dark ? "bg-gray-900" : "bg-gray-100 dark:bg-gray-900"}`}
    >
      <section className="flex container py-12 md:py-24 lg:py-36  px-5 mx-auto items-center">
        <div className="relative w-full md:w-2/3 lg:w-1/2 lg:pl-7 flex flex-wrap">
          <div className="flex flex-wrap mt-auto mb-auto w-full content-start z-30">
            <div className="w-full mb-6">
              {topCta ?? <TitleTag>{tag}</TitleTag>}
              <HeroTitle dark={dark}>{title}</HeroTitle>
              <div className="mt-3 mb-6 lg:max-w-3xl">
                <LeadText dark={dark}>{description}</LeadText>
              </div>
              {cta}
            </div>
          </div>
          {!dark && (
            <Pattern
              type="square"
              className="hidden lg:block absolute h-40 w-2/3 -bottom-16 left:0 xl:-left-20 text-gray-200 dark:text-gray-700 opacity-70 z-20"
            ></Pattern>
          )}
        </div>
        <div className="hidden md:block w-1/3 lg:w-1/2 flex-shrink-0 z-20">
          <img
            className="h-[10rem] lg:h-[20rem] mx-auto max-w-[30rem]"
            src={image}
            alt="Hero image"
          />
        </div>
      </section>

      <svg
        className={`hidden md:block absolute h-2/5 w-1/6 top-0 right-0 ${
          dark ? "text-gray-700" : "text-gray-200 dark:text-gray-700"
        } opacity-70`}
      >
        <defs>
          <pattern
            id="squares-pattern"
            x="0"
            y="0"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              fill="currentColor"
              d="M6 18h12V6H6v12zM4 4h16v16H4V4z"
            ></path>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#squares-pattern)" />
      </svg>
    </div>
  );
};

export default ImageHero4;
